export enum ParticipationItemType {
  RATING = 'rating',
  SURVEY = 'survey',
  POLL = 'poll',
}
